export default __webpack_public_path__ + "static/media/carouselImage2.c6db54e7.jpg";